webpackJsonp([37,110,111,273],{

/***/ 1144:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            total: 200,
            current: 10,
            perPage: 10,
            rangeBefore: 3,
            rangeAfter: 1,
            order: '',
            size: '',
            isSimple: false,
            isRounded: false,
            prevIcon: 'chevron-left',
            nextIcon: 'chevron-right'
        };
    }
});

/***/ }),

/***/ 1145:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', {
    attrs: {
      "grouped": "",
      "group-multiline": ""
    }
  }, [_c('b-field', {
    attrs: {
      "label": "Total"
    }
  }, [_c('b-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.total),
      callback: function($$v) {
        _vm.total = $$v
      },
      expression: "total"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Items per page"
    }
  }, [_c('b-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.perPage),
      callback: function($$v) {
        _vm.perPage = $$v
      },
      expression: "perPage"
    }
  })], 1)], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "grouped": "",
      "group-multiline": ""
    }
  }, [_c('b-field', {
    attrs: {
      "label": "Show buttons before current"
    }
  }, [_c('b-input', {
    attrs: {
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.rangeBefore),
      callback: function($$v) {
        _vm.rangeBefore = $$v
      },
      expression: "rangeBefore"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Show buttons after current"
    }
  }, [_c('b-input', {
    attrs: {
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.rangeAfter),
      callback: function($$v) {
        _vm.rangeAfter = $$v
      },
      expression: "rangeAfter"
    }
  })], 1)], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "grouped": "",
      "group-multiline": ""
    }
  }, [_c('b-field', {
    attrs: {
      "label": "Order"
    }
  }, [_c('b-select', {
    model: {
      value: (_vm.order),
      callback: function($$v) {
        _vm.order = $$v
      },
      expression: "order"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("default")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-centered"
    }
  }, [_vm._v("is-centered")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-right"
    }
  }, [_vm._v("is-right")])])], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Size"
    }
  }, [_c('b-select', {
    model: {
      value: (_vm.size),
      callback: function($$v) {
        _vm.size = $$v
      },
      expression: "size"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("default")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-small"
    }
  }, [_vm._v("is-small")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-medium"
    }
  }, [_vm._v("is-medium")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-large"
    }
  }, [_vm._v("is-large")])])], 1)], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "grouped": "",
      "group-multiline": ""
    }
  }, [_c('b-field', {
    attrs: {
      "label": "Previous icon"
    }
  }, [_c('b-select', {
    model: {
      value: (_vm.prevIcon),
      callback: function($$v) {
        _vm.prevIcon = $$v
      },
      expression: "prevIcon"
    }
  }, [_c('option', {
    attrs: {
      "value": "chevron-left"
    }
  }, [_vm._v("Chevron")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "arrow-left"
    }
  }, [_vm._v("Arrow")])])], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Next icon"
    }
  }, [_c('b-select', {
    model: {
      value: (_vm.nextIcon),
      callback: function($$v) {
        _vm.nextIcon = $$v
      },
      expression: "nextIcon"
    }
  }, [_c('option', {
    attrs: {
      "value": "chevron-right"
    }
  }, [_vm._v("Chevron")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "arrow-right"
    }
  }, [_vm._v("Arrow")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('b-switch', {
    model: {
      value: (_vm.isSimple),
      callback: function($$v) {
        _vm.isSimple = $$v
      },
      expression: "isSimple"
    }
  }, [_vm._v("Simple")]), _vm._v(" "), _c('b-switch', {
    model: {
      value: (_vm.isRounded),
      callback: function($$v) {
        _vm.isRounded = $$v
      },
      expression: "isRounded"
    }
  }, [_vm._v("Rounded")])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('b-pagination', {
    attrs: {
      "total": _vm.total,
      "current": _vm.current,
      "range-before": _vm.rangeBefore,
      "range-after": _vm.rangeAfter,
      "order": _vm.order,
      "size": _vm.size,
      "simple": _vm.isSimple,
      "rounded": _vm.isRounded,
      "per-page": _vm.perPage,
      "icon-prev": _vm.prevIcon,
      "icon-next": _vm.nextIcon,
      "aria-next-label": "Next page",
      "aria-previous-label": "Previous page",
      "aria-page-label": "Page",
      "aria-current-label": "Current page"
    },
    on: {
      "update:current": function($event) {
        _vm.current = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1146:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            current: 10,
            basicRomanNumeral: ['', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', '', 'X', 'XX', 'XXX', 'XL', 'L', 'LX', 'LXX', 'LXXX', 'XC', '', 'C', 'CC', 'CCC', 'CD', 'D', 'DC', 'DCC', 'DCCC', 'CM', '', 'M', 'MM', 'MMM']
        };
    },

    methods: {
        convertToRoman: function convertToRoman(num) {
            var _this = this;

            var numArray = num.toString().split('');
            var base = numArray.length;
            var count = base - 1;
            var convertedRoman = numArray.reduce(function (roman, digit) {
                var digitRoman = _this.basicRomanNumeral[+digit + count * 10];
                var result = roman + digitRoman;
                count -= 1;
                return result;
            }, '');
            return convertedRoman;
        }
    },
    watch: {
        $route: {
            immediate: true,
            handler: function handler(newVal, oldVal) {
                if (newVal.hash) {
                    this.current = parseInt(newVal.hash.replace(/\#page/g, ''));
                }
            }
        }
    }
});

/***/ }),

/***/ 1147:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-pagination', {
    attrs: {
      "total": 200,
      "current": _vm.current,
      "per-page": 10
    },
    on: {
      "update:current": function($event) {
        _vm.current = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return _c('b-pagination-button', {
          attrs: {
            "page": props.page,
            "id": ("page" + (props.page.number)),
            "tag": "router-link",
            "to": ("/documentation/pagination#page" + (props.page.number))
          }
        }, [_vm._v("\n                " + _vm._s(_vm.convertToRoman(props.page.number)) + "\n            ")])
      }
    }, {
      key: "previous",
      fn: function(props) {
        return _c('b-pagination-button', {
          attrs: {
            "page": props.page,
            "tag": "router-link",
            "to": ("/documentation/pagination#page" + (props.page.number))
          }
        }, [_vm._v("\n                Previous\n            ")])
      }
    }, {
      key: "next",
      fn: function(props) {
        return _c('b-pagination-button', {
          attrs: {
            "page": props.page,
            "tag": "router-link",
            "to": ("/documentation/pagination#page" + (props.page.number))
          }
        }, [_vm._v("\n                Next\n            ")])
      }
    }])
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1459:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_pagination__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__examples_ExSimple__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__examples_ExSimple___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__examples_ExSimple__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__raw_loader_examples_ExSimple__ = __webpack_require__(1460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__raw_loader_examples_ExSimple___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__raw_loader_examples_ExSimple__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__examples_ExSlot__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__examples_ExSlot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__examples_ExSlot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__raw_loader_examples_ExSlot__ = __webpack_require__(1461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__raw_loader_examples_ExSlot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__raw_loader_examples_ExSlot__);
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            api: __WEBPACK_IMPORTED_MODULE_0__api_pagination__["default"],
            ExSimple: __WEBPACK_IMPORTED_MODULE_1__examples_ExSimple___default.a,
            ExSimpleCode: __WEBPACK_IMPORTED_MODULE_2__raw_loader_examples_ExSimple___default.a,
            ExSlot: __WEBPACK_IMPORTED_MODULE_3__examples_ExSlot___default.a,
            ExSlotCode: __WEBPACK_IMPORTED_MODULE_4__raw_loader_examples_ExSlot___default.a
        };
    }
});

/***/ }),

/***/ 1460:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <b-field grouped group-multiline>\n            <b-field label=\"Total\">\n                <b-input type=\"number\" v-model=\"total\"></b-input>\n            </b-field>\n            <b-field label=\"Items per page\">\n                <b-input type=\"number\" v-model=\"perPage\"></b-input>\n            </b-field>\n        </b-field>\n        <b-field grouped group-multiline>\n            <b-field label=\"Show buttons before current\">\n                <b-input type=\"number\" v-model=\"rangeBefore\" min=\"0\"></b-input>\n            </b-field>\n            <b-field label=\"Show buttons after current\">\n                <b-input type=\"number\" v-model=\"rangeAfter\" min=\"0\"></b-input>\n            </b-field>\n        </b-field>\n        <b-field grouped group-multiline>\n            <b-field label=\"Order\">\n                <b-select v-model=\"order\">\n                    <option value=\"\">default</option>\n                    <option value=\"is-centered\">is-centered</option>\n                    <option value=\"is-right\">is-right</option>\n                </b-select>\n            </b-field>\n            <b-field label=\"Size\">\n                <b-select v-model=\"size\">\n                    <option value=\"\">default</option>\n                    <option value=\"is-small\">is-small</option>\n                    <option value=\"is-medium\">is-medium</option>\n                    <option value=\"is-large\">is-large</option>\n                </b-select>\n            </b-field>\n        </b-field>\n        <b-field grouped group-multiline>\n            <b-field label=\"Previous icon\">\n                <b-select v-model=\"prevIcon\">\n                    <option value=\"chevron-left\">Chevron</option>\n                    <option value=\"arrow-left\">Arrow</option>\n                </b-select>\n            </b-field>\n            <b-field label=\"Next icon\">\n                <b-select v-model=\"nextIcon\">\n                    <option value=\"chevron-right\">Chevron</option>\n                    <option value=\"arrow-right\">Arrow</option>\n                </b-select>\n            </b-field>\n        </b-field>\n        <div class=\"block\">\n            <b-switch v-model=\"isSimple\">Simple</b-switch>\n            <b-switch v-model=\"isRounded\">Rounded</b-switch>\n        </div>\n\n        <hr>\n        <b-pagination\n            :total=\"total\"\n            :current.sync=\"current\"\n            :range-before=\"rangeBefore\"\n            :range-after=\"rangeAfter\"\n            :order=\"order\"\n            :size=\"size\"\n            :simple=\"isSimple\"\n            :rounded=\"isRounded\"\n            :per-page=\"perPage\"\n            :icon-prev=\"prevIcon\"\n            :icon-next=\"nextIcon\"\n            aria-next-label=\"Next page\"\n            aria-previous-label=\"Previous page\"\n            aria-page-label=\"Page\"\n            aria-current-label=\"Current page\">\n        </b-pagination>\n    </section>\n</template>\n\n<script>\n    export default {\n        data() {\n            return {\n                total: 200,\n                current: 10,\n                perPage: 10,\n                rangeBefore: 3,\n                rangeAfter: 1,\n                order: '',\n                size: '',\n                isSimple: false,\n                isRounded: false,\n                prevIcon: 'chevron-left',\n                nextIcon: 'chevron-right'\n            }\n        }\n    }\n</script>\n"

/***/ }),

/***/ 1461:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <b-pagination\n            :total=\"200\"\n            :current.sync=\"current\"\n            :per-page=\"10\">\n\n            <b-pagination-button\n                slot-scope=\"props\"\n                :page=\"props.page\"\n                :id=\"`page${props.page.number}`\"\n                tag=\"router-link\"\n                :to=\"`/documentation/pagination#page${props.page.number}`\">\n                {{ convertToRoman(props.page.number) }}\n            </b-pagination-button>\n\n            <b-pagination-button\n                slot=\"previous\"\n                slot-scope=\"props\"\n                :page=\"props.page\"\n                tag=\"router-link\"\n                :to=\"`/documentation/pagination#page${props.page.number}`\">\n                Previous\n            </b-pagination-button>\n\n            <b-pagination-button\n                slot=\"next\"\n                slot-scope=\"props\"\n                :page=\"props.page\"\n                tag=\"router-link\"\n                :to=\"`/documentation/pagination#page${props.page.number}`\">\n                Next\n            </b-pagination-button>\n\n        </b-pagination>\n    </section>\n</template>\n\n<script>\n    export default {\n        data() {\n            return {\n                current: 10,\n                basicRomanNumeral: ['',\n                    'I','II','III','IV','V','VI','VII','VIII','IX','',\n                    'X','XX','XXX','XL','L','LX','LXX','LXXX','XC','',\n                    'C','CC','CCC','CD','D','DC','DCC','DCCC','CM','',\n                    'M','MM','MMM'\n                ]\n            }\n        },\n        methods: {\n            convertToRoman(num) {\n                const numArray = num.toString().split('');\n                const base = numArray.length;\n                let count = base-1;\n                const convertedRoman = numArray.reduce((roman, digit) => {\n                    const digitRoman = this.basicRomanNumeral[+digit + count*10];\n                    const result = roman + digitRoman;\n                    count -= 1;\n                    return result;\n                },'');\n                return convertedRoman;\n            }\n        },\n        watch: {\n            $route: {\n                immediate: true,\n                handler(newVal, oldVal) {\n                    if (newVal.hash) {\n                        this.current = parseInt(newVal.hash.replace(/\\#page/g, ''))\n                    }\n                },\n            },\n        }\n    }\n</script>\n"

/***/ }),

/***/ 1462:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Example', {
    attrs: {
      "component": _vm.ExSimple,
      "code": _vm.ExSimpleCode
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExSlot,
      "code": _vm.ExSlotCode,
      "title": "Custom pagination buttons"
    }
  }, [_c('p', [_vm._v("You can customize the buttons using "), _c('b', [_c('code', [_vm._v("b-pagination-button")])]), _vm._v(" as scoped slot.")]), _vm._v(" "), _c('p', [_vm._v("For example, you can customize the inner text or use "), _c('code', [_vm._v("router-link")]), _vm._v(" as tag.")])]), _vm._v(" "), _c('ApiView', {
    attrs: {
      "data": _vm.api
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 234:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ([{
    title: 'Pagination',
    props: [{
        name: '<code>total</code>',
        description: 'Total count of items',
        type: 'Number',
        values: '—',
        default: '—'
    }, {
        name: '<code>per-page</code>',
        description: 'Items count for each page',
        type: 'Number',
        values: '—',
        default: '<code>20</code>'
    }, {
        name: '<code>range-before</code>',
        description: 'Number of pagination items to show before current page',
        type: 'Number',
        values: '—',
        default: '<code>1</code>'
    }, {
        name: '<code>range-after</code>',
        description: 'Items to paginatation items to show after current page',
        type: 'Number',
        values: '—',
        default: '<code>1</code>'
    }, {
        name: '<code>current</code>',
        description: 'Current page number, use the <code>.sync</code> modifier to make it two-way binding',
        type: 'Number',
        values: '—',
        default: '<code>1</code>'
    }, {
        name: '<code>order</code>',
        description: 'Buttons order, optional',
        type: 'String',
        values: '<code>is-centered</code>, <code>is-right</code>',
        default: '—'
    }, {
        name: '<code>size</code>',
        description: 'Pagination size, optional',
        type: 'String',
        values: '<code>is-small</code>, <code>is-medium</code>, <code>is-large</code>',
        default: '—'
    }, {
        name: '<code>simple</code>',
        description: 'Simpler style',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>rounded</code>',
        description: 'Rounded button styles',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>icon-pack</code>',
        description: 'Icon pack to use',
        type: 'String',
        values: '<code>mdi</code>, <code>fa</code>, <code>fas</code>, <code>far</code>, <code>fad</code>, <code>fal</code>',
        default: '<code>mdi</code>'
    }, {
        name: '<code>icon-prev</code>',
        description: 'Icon to use for previous button',
        type: 'String',
        values: '—',
        default: '<code>chevron-left</code>'
    }, {
        name: '<code>icon-next</code>',
        description: 'Icon to use for next button',
        type: 'String',
        values: '—',
        default: '<code>chevron-right</code>'
    }, {
        name: '<code>aria-next-label</code>',
        description: 'Accessibility label for the next page link.',
        type: 'String',
        values: '—',
        default: '—'
    }, {
        name: '<code>aria-previous-label</code>',
        description: 'Accessibility label for the previous page link.',
        type: 'String',
        values: '—',
        default: '—'
    }, {
        name: '<code>aria-page-label</code>',
        description: 'Accessibility label for the page link. If passed, this text will be prepended to the number of the page.',
        type: 'String',
        values: '—',
        default: '—'
    }, {
        name: '<code>aria-current-label</code>',
        description: 'Accessibility label for the current page link. If passed, this text will be prepended to the current page.',
        type: 'String',
        values: '—',
        default: '—'
    }],
    slots: [{
        name: 'default',
        description: 'This is to customize numbered pagination buttons with the Button subcomponent.',
        props: '<code>:page="props.page"</code>'
    }, {
        name: 'next',
        description: 'This is to customize the next pagination button with the Button subcomponent.',
        props: '<code>:page="props.page"</code>'
    }, {
        name: 'previous',
        description: 'This is to customize the previous pagination button with the Button subcomponent.',
        props: '<code>:page="props.page"</code>'
    }],
    events: [{
        name: '<code>change</code>',
        description: 'Triggers when the current page is changed',
        parameters: '<code>value: Number</code>'
    }]
}, {
    title: 'Button',
    props: [{
        name: '<code>page</code>',
        description: 'The prop page need to be passed upon the component (<code>:page="props.page"</code>).',
        type: 'Object',
        values: '—',
        default: '—'
    }, {
        name: '<code>tag</code>',
        description: 'Button tag name',
        type: 'String',
        values: '<code>a</code>, <code>button</code>, <code>input</code>, <code>router-link</code>, <code>nuxt-link</code> or other nuxt alias',
        default: '<code>a</code>'
    }],
    slots: [{
        name: 'default',
        description: '<strong>Required</strong>, pagination button content',
        props: '-'
    }]
}]);

/***/ }),

/***/ 235:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1144),
  /* template */
  __webpack_require__(1145),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 236:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1146),
  /* template */
  __webpack_require__(1147),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 377:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1459),
  /* template */
  __webpack_require__(1462),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/37.4a6bb1bddfe2491d71fb.js